import { render, staticRenderFns } from "./CVPreview.vue?vue&type=template&id=5f1308e9&"
import script from "./CVPreview.vue?vue&type=script&lang=js&"
export * from "./CVPreview.vue?vue&type=script&lang=js&"
import style0 from "./CVPreview.vue?vue&type=style&index=0&id=5f1308e9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports